module.exports = __webpack_public_path__ + "static/media/ic_mask_start.f7e03c89.svg";